export default {
  metadata: {
    version: '1.0.0',
    id: 'accordion-list-1.0.0',
    name: 'JDSAccordionList'
  },
  hierarchy: {
    'root-container': [
      {
        container: ['jds_accordion']
      },
      'content-slot'
    ]
  },
  base: {
    'root-container': {
      'flex-direction': '{a_0}',
      width: '{a_1}'
    },
    container: {
      hidden: true,
      'flex-direction': '{a_2}',
      width: '{a_3}'
    },
    'content-slot': {
      hidden: false
    }
  },
  variant: {
    _hasItems: {
      true: {
        'content-slot': {
          hidden: true
        },
        container: {
          hidden: false
        }
      }
    }
  },
  api: {
    data: {
      container: {
        value: {
          type: 'list',
          name: 'items',
          function: true,
          object: {
            children: 'slot',
            prefix: 'slot',
            expandedPanel: 'boolean',
            showDivider: 'boolean',
            disabled: 'boolean',
            title: 'string',
            subtitle: 'string',
            onClick: 'event'
          }
        }
      },
      jds_accordion: {
        iconType: {
          type: 'JDSAccordion.iconType',
          name: 'iconType'
        },
        children: {
          type: 'slot',
          name: 'items.children'
        },
        prefix: {
          type: 'slot',
          name: 'items.prefix'
        },
        expandedPanel: {
          type: 'boolean',
          name: 'items.expandedPanel'
        },
        disabled: {
          type: 'boolean',
          name: 'items.disabled'
        },
        title: {
          type: 'string',
          name: 'items.title'
        },
        showDivider: {
          type: 'boolean',
          name: 'items.showDivider'
        },
        subtitle: {
          type: 'string',
          name: 'items.subtitle'
        },
        onClick: {
          type: 'event',
          name: 'items.onClick'
        }
      }
    },
    config: {
      iconType: {
        type: 'JDSAccordion.iconType',
        values: ['chevron', 'plus']
      },
      allowMultiple: {
        values: [false, true]
      },
      _hasItems: {
        values: [false, true]
      }
    },
    children: {
      'content-slot': {
        name: 'children',
        accepts: ['jds_accordion']
      }
    },
    a11y: {
      container: {
        name: 'items',
        repeating: {
          buttonAriaLabel: 'buttonAriaLabel'
        }
      },
      jds_accordion: {
        properties: {
          buttonAriaLabel: 'items.buttonAriaLabel'
        }
      }
    }
  }
};
